<template>
    <el-dialog
        ref="DetailDialog"
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        append-to-body
        class="ah-export-preview-dialog"
        top="0vh"
        @open="onOpen"
        @close="onClose"
        @closed="onClosed"
    >
        <div class="layout">
            <div v-if="showCloseButton" class="default-close-btn"></div>
            <div class="dialog-preview">
                <slot name="preview">Preview</slot>
            </div>
            <div class="dialog-main">
                <div class="dialog-main-header">
                    <div class="dialog-main-header-title">
                        <slot name="title">{{ title }}</slot>
                    </div>
                    <div class="header-right">
                        <slot name="header-right"></slot>
                    </div>
                </div>
                <div class="dialog-main-body">
                    <slot></slot>
                </div>
                <div class="dialog-main-footer">
                    <slot name="footer">
                        <el-button @click="onClose" icon="el-icon-close" :disabled="isExporting">取消</el-button>
                        <el-button
                            type="primary"
                            style="min-width: 100px;"
                            @click="onExport"
                            icon="el-icon-check"
                            :loading="isExporting"
                        >{{ exportButtonText }}</el-button>
                    </slot>
                </div>
            </div>
        </div>
        <div v-if="isExporting" class="progress-view">
            <div class="progress-panel">
                <div class="panel-title">匯出中</div>
                <div class="progress-bar">
                    <el-progress :percentage="progress" :show-text="false" :stroke-width="10"></el-progress>
                </div>
                <div class="progress-msg">{{ this.progressMessage }}</div>
            </div>
        </div>
    </el-dialog>
</template>
<script>

export default {
    name: 'export-preivew-dialog',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '匯出',
        },
        showCloseButton: {
            type: Boolean,
            default: false,
        },
        isExporting: {
            type: Boolean,
            default: false,
        },
        exportButtonText: {
            type: String,
            default: '匯出',
        },
        cancelButtonText: {
            type: String,
            default: '取消',
        },
        progress: {
            type: Number,
            default: 0,
        },
        progressMessage: {
            type: String,
            default: 'Exporting...',
        },
    },
    data() {
        return {
        };
    },
    methods: {
        onOpen() {
            this.$emit('open');
        },
        onClose() {
            this.$emit('close');
        },
        onClosed() {
            this.$emit('closed');
        },
        onExport() {
            this.$emit('export');
        },
    },
};
</script>
<style lang="scss">

.ah-export-preview-dialog {
    $borderRadius: 20px;
    $mainPadding: 25px;
    $maxHeight: 560;

    .el-dialog {
        top: 4vh;
        background-color: #fff;
        width: calc(100% - 10px);
        // height: calc(100vh - 8vh);
        // margin-bottom: 0 !important;
        border-radius: $borderRadius;

        @media (min-width: 720px) {
            max-width: 780px;
            max-height: 500px;
            height: calc(100vh - 8vh);
        }

        .el-dialog__header {
            display: none;
        }
        .el-dialog__body {
            padding: 0;
            height: 100%;
        }
    }

    .layout {
        display: block;
        height: auto;

        @media (min-width: 720px) {
            display: grid;
            height: 100%;
            grid-template-columns: auto 330px;
        }

        >.dialog-preview {
            aspect-ratio: 1 / 1;
            background-color: #f1f1f1;
            border-top-left-radius: $borderRadius;
            border-top-right-radius: $borderRadius;
            border-bottom-left-radius: $borderRadius;
            border-bottom-right-radius: $borderRadius;
            border: 10px solid #fff;
            overflow: auto;
            &::-webkit-scrollbar {
                width: 12px;
            }
            &::-webkit-scrollbar-track {
                background: transparent;        /* color of the tracking area */
            }
            &::-webkit-scrollbar-thumb {
                background-color: #ddd;    /* color of the scroll thumb */
                border-radius: 20px;       /* roundness of the scroll thumb */
                border: 3px solid #eee;
                transition: background-color 0.2s;
            }
            &::-webkit-scrollbar-thumb:hover {
                background-color: #ccc;
            }

            @media (min-width: 720px) {
                display: block;
                aspect-ratio: unset;
                border-top-left-radius: $borderRadius;
                border-top-right-radius: $borderRadius;
                border-bottom-left-radius: $borderRadius;
                border-bottom-right-radius: $borderRadius;
            }
        }
        >.dialog-main {
            display: grid;
            grid-template-rows: 80px minmax(0, 1fr) 80px;
            height: 100%;
            overflow: hidden;
            color: #444;

            >.dialog-main-header {
                padding: $mainPadding;
                padding-top: 30px;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            >.dialog-main-body {
                height: 100%;
                overflow-y: auto;
                padding: 0 $mainPadding;
            }
            >.dialog-main-footer {
                display: flex;
                flex: none;
                align-items: center;
                justify-content: flex-end;
                padding: 0 $mainPadding;
            }
        }
        .default-preview {
            display: flex;
            height: 100%;
            // justify-content: center;
            // align-items: center;
        }
        .dialog-main-header-title {
            font-size: 14pt;
            font-weight: bold;
        }
        .dialog-main-header-right {
            font-size: 11pt;
        }
        .default-close-btn {
            position: absolute;
            top: $mainPadding;
            right: $mainPadding;
            display: flex;
            background-color: #eee;
            width: 26px;
            height: 26px;
            border-radius: 6px;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            &::before {
                content: "";
                display: block;
                width: 12px;
                height: 1px;
                background-color: #888;
                transform: translateX(50%) rotate(45deg);
            }
            &::after {
                content: "";
                display: block;
                width: 12px;
                height: 1px;
                background-color: #888;
                transform: translateX(-50%) rotate(-45deg);
            }
        }
    }

    .progress-view {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: $borderRadius;
        z-index: 20;

        >.progress-panel {
            width: 400px;
            background-color: #fff;
            padding: 25px;
            border-radius: 8px;

            .panel-title {
                font-size: 11pt;
                font-weight: bold;
                color: #000;
                margin-bottom: 15px;
            }
            .progress-msg {
                margin-top: 10px;
                font-size: 9pt;
                color: #666;
            }
        }
    }

    .preview-doc-list {
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: 100%;
        align-items: center;
        padding: 50px 0;
        height: unset;

        >.preview-doc {
            display: block;
            width: 60%;
            background-color: #fff;
            border: 1px solid #ccc;
            aspect-ratio: 21 / 29.7;
            padding: 5%;
            font-size: 5pt;
            line-height: 6pt;
            color: #000;

            .company-name {
                font-size: 5pt;
                font-weight: bold;
                margin-bottom: 3px;
            }

            .doc-title {
                font-size: 8pt;
                line-height: 9pt;
                font-weight: bold;
                margin-bottom: 10px;
            }

            .text-line {
                width: 100%;
                height: 1px;
                background-color: #ccc;
                margin-bottom: 3px;
            }

            table {
                font-size: 4pt;
                line-height: 5pt;
                width: 100%;
                border-top: 1px solid #000;
                border-right: 1px solid #000;
            }
            th {
                padding: 2px 0;
            }
            th, td {
                border-left: 1px solid #000;
                border-bottom: 1px solid #000;
            }
        }
    }

    .setting-item {
        padding: 5px 0;
        .label {
            color: #888;
            font-size: 9pt;
            margin-bottom: 3px;
        }
    }
}
</style>
